export default "__VITE_ASSET__61903085__"